export { default } from './MenuList';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/MenuList/index.js
// module id = 141
// module chunks = 0